import {push} from "connected-react-router";

const redirect= (path) => async (dispatch) => {
  dispatch(push(path));
};
export default redirect;